import { faBedFront } from '@fortawesome/pro-light-svg-icons'
import {
  ResidentialApartmentPropertyDetails,
  ResidentialHousePropertyDetails,
  ResidentialType,
} from '@unreserved-frontend-v2/api/generated/graphql/types'
import { DetailsTableCell } from '@unreserved-frontend-v2/ui/details-table/models'
import useTranslation from 'next-translate/useTranslation'
import { useMemo } from 'react'
import { bedsBreakdown } from '../../../../utils/formatters/beds-breakdown'

const ABOVE_GRADE = 0
const BELOW_GRADE = 1
const DENS = 1

export const useBedsCell = (
  details?: ResidentialApartmentPropertyDetails | ResidentialHousePropertyDetails | null
): DetailsTableCell => {
  const { t } = useTranslation()
  return useMemo(() => {
    const breakdown = bedsBreakdown(details)
    const isApartment = details?.residentialType === ResidentialType.Apartment
    const beds = details?.beds || 0

    let value = ''
    let label = t('listings:details-pages.beds', { count: beds })

    if (!isApartment) {
      let count = breakdown[ABOVE_GRADE]
      value = count ? t('listings:details-pages.above', { count }) : ''
      if (breakdown[BELOW_GRADE]) {
        count = breakdown[BELOW_GRADE]
        value += count ? ` - ${t('listings:details-pages.below', { count })}` : ''
      }
    } else if (breakdown[DENS]) {
      label += ` + ${t('listings:details-pages.dens', { count: breakdown[DENS] })}`
    }

    return {
      id: 'beds',
      data: [
        {
          id: 'data-beds',
          icon: faBedFront,
          iconCount: beds,
          label,
          value,
          type: 'iconCounter',
        },
      ],
    }
  }, [details, t])
}
